import '../styles/PageGlobal.css';
import './HomePage.css';
import React from "react";
import {getChart1,getChart2,getChart3,getChart4,getChart5,getChart6} from "../services/Api.service";
import ChartBox from "../components/ChartBox";
import { useParams } from "react-router-dom";


export default function HomePage() {
  const { user_id } = useParams();

  return (
    <div className="containerMain">
  <h1>Accueil</h1>
  <p>Ceci est un contenu protégé</p>

  <div className="dashboard-grid">
    <ChartBox userId={user_id} fetchData={getChart1} />
      <ChartBox userId={user_id} fetchData={getChart2} />
      <ChartBox userId={user_id} fetchData={getChart3} />
      <ChartBox userId={user_id} fetchData={getChart4} />
      <ChartBox userId={user_id} fetchData={getChart5} />
      <ChartBox fetchData={getChart6} />
  </div>
</div>
  );
}